import { render, staticRenderFns } from "./langSelect.vue?vue&type=template&id=0249b44b&scoped=true"
import script from "./langSelect.vue?vue&type=script&lang=js"
export * from "./langSelect.vue?vue&type=script&lang=js"
import style0 from "./langSelect.vue?vue&type=style&index=0&id=0249b44b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0249b44b",
  null
  
)

export default component.exports